import { BaseActionProps } from "../types";
import { RiChatAiLine, RiCheckLine } from "@remixicon/react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Portal } from "@radix-ui/react-tooltip";

interface AskAIActionProps extends BaseActionProps {
  isAttached: boolean;
  onAskAI: () => void;
  onDetach: () => void;
}

const AskAIAction = ({ isAttached, onAskAI, onDetach }: AskAIActionProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size={"sm"}
            onClick={(e) => {
              e.stopPropagation();
              if (isAttached) {
                onDetach();
              } else {
                onAskAI();
              }
            }}
            className={cn(
              "squircle-mask border-none backdrop-blur-sm flex items-center gap-[6px] px-[10px] py-[6px] rounded-[8px] transition-all duration-200",
              "text-[12px] font-medium leading-[16px] tracking-[0.24px]",
              isAttached
                ? "bg-[linear-gradient(90deg,_rgba(255,87,26,0.7)_0%,_rgba(255,98,146,0.7)_100%)] hover:bg-[linear-gradient(90deg,_rgba(255,87,26,0.8)_0%,_rgba(255,98,146,0.8)_100%)] text-white cursor-pointer"
                : "bg-white/70 hover:bg-white/90 text-brand-primary-new cursor-pointer",
            )}
          >
            {isAttached ? (
              <RiCheckLine size={14} className="shrink-0 text-white" />
            ) : (
              <RiChatAiLine
                size={14}
                className={cn(
                  "shrink-0",
                  isAttached ? "text-white" : "text-brand-orange",
                )}
              />
            )}
            <span>{isAttached ? "Attached" : "Ask AI"}</span>
          </Button>
        </TooltipTrigger>
        <Portal>
          <TooltipContent
            side="bottom"
            align="start"
            className="squircle-mask max-w-[260px]"
          >
            {isAttached
              ? "Remove this creative"
              : "Interact with the creative and performance data for this range and all time."}
          </TooltipContent>
        </Portal>
      </Tooltip>
    </TooltipProvider>
  );
};

export default AskAIAction;
